import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form__legend" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Legend',
  props: {
    title: {}
  },
  setup(__props: any) {

// eslint-disable-next-line


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("legend", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
  ]))
}
}

})